import { render, staticRenderFns } from "./viewProdutos.vue?vue&type=template&id=00470280&scoped=true&"
import script from "./viewProdutos.vue?vue&type=script&lang=js&"
export * from "./viewProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00470280",
  null
  
)

export default component.exports